import { render, staticRenderFns } from "./OKBYVTQF.vue?vue&type=template&id=d0c9e2d8&scoped=true"
import script from "./OKBYVTQF.vue?vue&type=script&lang=js"
export * from "./OKBYVTQF.vue?vue&type=script&lang=js"
import style0 from "./OKBYVTQF.vue?vue&type=style&index=0&id=d0c9e2d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c9e2d8",
  null
  
)

export default component.exports